import React from 'react';
import './Footer.css';
import { FaLinkedin, FaTwitter, FaFacebook, FaEnvelope, FaPhone } from 'react-icons/fa';
import logo from '../assets/images/logo.jpeg';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">
              <img src={logo} alt="LTSS Logo" className="footer-logo-img" />
              <span className="logo-text">LTSS</span>
            </h3>
            <p className="footer-description">
              Your trusted partner for lead generation, recruitment support, and virtual assistance services worldwide.
            </p>
            {/* <div className="social-links">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaLinkedin />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaTwitter />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaFacebook />
              </a>
            </div> */}
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#industries">Industries</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><a href="#services">Lead Generation</a></li>
              <li><a href="#services">Candidate Sourcing</a></li>
              <li><a href="#services">LinkedIn Prospecting</a></li>
              <li><a href="#services">Database Management</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Us</h4>
            <ul className="footer-contact">
              <li>
                <FaEnvelope className="contact-icon" />
                <a href="mailto:Iqbal@leadstalentsourcingsolutions.com">
                Iqbal@leadstalentsourcingsolutions.com
                </a>
              </li>
              <li>
                <FaEnvelope className="contact-icon" />
                <a href="mailto:Info@leadstalentsourcingsolutions.com">
                  Info@leadstalentsourcingsolutions.com
                </a>
              </li>
              <li>
                <FaPhone className="contact-icon" />
                <a href="tel:+27065841703">+27-065-841-7038</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} LTSS. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;